<template>
  <VueContentLoading
    :primary="$scss.colors.cardBg"
    :secondary="$scss.colors.inputBg"
    :width="300"
    :height="600"
  >
    <!--stage mask-->
    <rect x="0" y="10" rx="4" ry="4" width="75%" height="30"></rect>
    <rect x="0" y="53" rx="4" ry="4" width="48.5%" height="18"></rect>
    <rect x="51.5%" y="53" rx="4" ry="4" width="48.5%" height="18"></rect>
    <rect x="0" y="80" rx="4" ry="4" width="100%" height="45"></rect>
    <rect x="0" y="133" rx="4" ry="4" width="100%" height="45"></rect>

    <!--block mask-->
    <rect x="0" y="198" rx="4" ry="4" width="80%" height="25"></rect>
    <rect x="82%" y="198" rx="4" ry="4" width="18%" height="25"></rect>
    <rect x="0" y="228" rx="4" ry="4" width="100%" height="84"></rect>

    <rect x="0" y="333" rx="4" ry="4" width="80%" height="25"></rect>
    <rect x="82%" y="333" rx="4" ry="4" width="18%" height="25"></rect>
    <rect x="0" y="363" rx="4" ry="4" width="100%" height="84"></rect>

    <rect x="0" y="468" rx="4" ry="4" width="80%" height="25"></rect>
    <rect x="82%" y="468" rx="4" ry="4" width="18%" height="25"></rect>
    <rect x="0" y="498" rx="4" ry="4" width="100%" height="84"></rect>
  </VueContentLoading>
</template>

<script>
import VueContentLoading from 'vue-content-loading';

export default {
  name: 'StageLoader',
  components: {
    VueContentLoading,
  },
};
</script>
